<!--
    EiToolingLogsTabComponent Template

    Controls at the top, widget grid below.
-->

<div class="flex align-items-center gap-2 mb-3 flex-wrap">
    <p-selectButton
            [options]="levelOptions"
            [(ngModel)]="selectedLevels"
            [multiple]="true"
            optionLabel="label"
            optionValue="value">
    </p-selectButton>
    <span class="flex-1"></span>
    <p-button
            label="Aktualisieren"
            icon="fa-solid fa-rotate-right"
            [text]="true"
            severity="secondary"
            size="small"
            (onClick)="refresh()">
    </p-button>
</div>

@if (traceWidget) {
    <mvs-widget [widgetData]="traceWidget"></mvs-widget>
} @else {
    <p-message
            severity="info"
            text="Kein Datensatz ausgewählt."
            [closable]="false">
    </p-message>
}
